"use client";

import type { Locale } from "@mw/shared/i18n";
import { createContext, useContext, type ReactNode } from "react";

export interface PageFooterData {
  enabledLocales?: Locale[] | null;
  missingLocaleBehavior?: "redirect-to-default" | "show-not-found" | "no-index" | null;
}

const PageFooterContext = createContext<PageFooterData>({});

export function PageFooterProvider({ children, data }: { children: ReactNode; data: PageFooterData }) {
  return <PageFooterContext.Provider value={data}>{children}</PageFooterContext.Provider>;
}

export function usePageFooterData() {
  return useContext(PageFooterContext);
}
